<template>
    <CustomDialog v-model="isVisible" :defaultTitle="title" width="900px" @cancel="close">
        <template #content>
            <div v-if="loading" class="ppv2-flex ppv2-justify-center ppv2-items-center ppv2-py-20">
                <i class="fas fa-spinner fa-spin ppv2-text-3xl ppv2-text-blue-500"></i>
            </div>
            <div v-else-if="details" class="ppv2-space-y-6">
                <!-- User Info Card -->
                <div class="ppv2-bg-white ppv2-border ppv2-border-gray-100 ppv2-rounded-2xl ppv2-p-8 ppv2-shadow-sm">
                    <h3 class="ppv2-text-2xl poppinsBold ppv2-text-gray-900 ppv2-mb-6">{{ details.full_name }}</h3>
                    <div class="ppv2-grid ppv2-grid-cols-2 ppv2-gap-x-12 ppv2-gap-y-6">
                        <div>
                            <p class="ppv2-text-xs ppv2-text-gray-400 ppv2-mb-1">{{ $t('quotes.answer_modal.email') }}</p>
                            <p class="ppv2-text-base poppinsMedium ppv2-text-gray-800">{{ details.email }}</p>
                        </div>
                        <div>
                            <p class="ppv2-text-xs ppv2-text-gray-400 ppv2-mb-1">{{ $t('quotes.answer_modal.phone') }}</p>
                            <p class="ppv2-text-base poppinsMedium ppv2-text-gray-800">{{ details.phone_number || '-' }}</p>
                        </div>
                    </div>
                </div>

                <!-- Questions & Answers Card -->
                <div class="ppv2-bg-[#FDFDFD] ppv2-border ppv2-border-gray-100 ppv2-rounded-2xl ppv2-p-8">
                    <div class="ppv2-grid ppv2-grid-cols-2 ppv2-gap-x-12 ppv2-gap-y-10">
                        <div
                            v-for="(answer, index) in details.answers"
                            :key="index"
                            :class="{ 'ppv2-col-span-2': isLongText(answer.answer) }"
                        >
                            <p class="ppv2-text-xs ppv2-text-gray-400 ppv2-mb-2">{{ answer.question }}</p>
                            <p class="ppv2-text-base poppinsMedium ppv2-text-gray-800 ppv2-leading-relaxed">
                                {{ answer.answer }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template #actions>
            <div class="ppv2-hidden"></div>
        </template>
    </CustomDialog>
</template>

<script>
import CustomDialog from '../Shared/CustomDialog.vue'
import BaseButton from '../Shared/BaseButton.vue'

export default {
    name: 'DevisAnswerDetailModal',
    components: { CustomDialog, BaseButton },
    props: {
        value: { type: Boolean, default: false },
        answerId: { type: [Number, String], default: null },
    },
    data() {
        return {
            loading: false,
            details: null,
        }
    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
        title() {
            return this.$t('quotes.answer_modal.title', { id: this.answerId || '' })
        },
    },
    watch: {
        value(val) {
            if (val && this.answerId) {
                this.fetchDetails()
            }
        },
    },
    methods: {
        async fetchDetails() {
            this.loading = true
            try {
                const response = await fetch(`/back-office/devis-v3/answer-details/${this.answerId}`)
                const data = await response.json()
                if (data.success) {
                    this.details = data.data
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
            }
        },
        isLongText(text) {
            return text && text.length > 50
        },
        close() {
            this.isVisible = false
        },
    },
}
</script>
